/* tslint:disable */

declare var Object: any;
export interface AttendanceMachineInterface {
  "id"?: number;
}

export class AttendanceMachine implements AttendanceMachineInterface {
  "id": number;
  constructor(data?: AttendanceMachineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AttendanceMachine`.
   */
  public static getModelName() {
    return "AttendanceMachine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AttendanceMachine for dynamic purposes.
  **/
  public static factory(data: AttendanceMachineInterface): AttendanceMachine{
    return new AttendanceMachine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AttendanceMachine',
      plural: 'AttendanceMachines',
      path: 'AttendanceMachines',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/AttendanceMachine.ts